import { Component, OnInit, Input, forwardRef, TemplateRef, Output, EventEmitter } from '@angular/core';
import { MasterService } from 'app/services/master/master.service';
import { MstConsultantModel } from 'app/model/mst.consultant.model';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'dropdown-base',
    templateUrl: './dropdown-base.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DropdownBaseComponent),
        multi: true
    }]
})

export abstract class DropdownBaseComponent implements ControlValueAccessor {

    @Input()
    required: any;

    @Input()
    errorMessage: string;

    @Output()
    blur = new EventEmitter();

    model: string;
    list: Array<any> = [];

    onChange  = (_: any) => {};

    constructor() {
    }

    selectOnChange() {
        this.onChange(this.model);
    }

    selectOnBlur(event: any) {
        this.blur.emit(event);
    }


    writeValue(value: any): void {
        this.model = value;
    }

    registerOnChange(fn: any): void {
        this.onChange  = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
    }
    registerOnTouched(fn: any): void {
    }

}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/dropdown/dropdown-base.component.ts